export default "__VITE_ASSET__CvfZ5IIT__"